import { AppInfoState } from '../app/state';
import { appSliceName } from '../app/constants';

export const RootState = {
  [appSliceName]: AppInfoState
};
